import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d431866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "memory__false-pairs-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_matrix_display = _resolveComponent("game-matrix-display")!
  const _component_game_info_point = _resolveComponent("game-info-point")!
  const _component_game_wrapper = _resolveComponent("game-wrapper")!

  return (_openBlock(), _createBlock(_component_game_wrapper, {
    title: "Memory",
    name: "Memory",
    "is-game-over": _ctx.isGameOver,
    counter: _ctx.restartCounter,
    "score-elements": _ctx.scoreElements,
    "action-buttons": _ctx.currentActionButtons,
    instruction: _ctx.currentInstruction,
    onPrecountdownOver: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gamePhase = 0)),
    onTurn: _ctx.turnMemory,
    onRestart: _ctx.restart
  }, {
    default: _withCtx(() => [
      _createVNode(_component_game_matrix_display, {
        class: "memory__memory",
        matrix: _ctx.memory,
        "max-width": _ctx.matrixDisplayWidth,
        "has-disabled-style": true,
        onItemClick: _ctx.clickMemoryItem
      }, null, 8, ["matrix", "max-width", "onItemClick"])
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.falsePairs, (point) => {
          return (_openBlock(), _createBlock(_component_game_info_point, {
            key: point.id,
            value: point.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(point.info), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["is-game-over", "counter", "score-elements", "action-buttons", "instruction", "onTurn", "onRestart"]))
}